<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" class="dialog-title-container">
  <h4 class="title-text">
    {{"Edit Rooms"}}
  </h4>
  <div fxLayoutGap="12px">
    <button mat-raised-button (click)="deleteRooms()">
      {{ "Delete"| translate }}
    </button>
    <button mat-raised-button color="primary" (click)="addNewLine()">
      {{ "Add"| translate }}
    </button>
  </div>
</div>
<mat-divider></mat-divider>
<mat-dialog-content fxLayout="column">
  <div class="list-container">
    <table>
      <thead>
        <tr class="header-row">
          <th></th>
          <th class="room-name-cell">
            {{ "Masters.clinics.RoomName"| translate }}
          </th>
          <th class="room-weight-cell">
            {{ "Masters.clinics.RoomWeight"| translate }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="detail-row" *ngFor="let room of roomsArray;let i = index" [id]="'row_'+i">
          <td></td>
          <td class="room-name-cell"><input class="input-field" placeholder="Enter Name" (blur)="verifyInputData(i)"
              [(ngModel)]="room.name" /></td>
          <td class="room-weight-cell"><input class="input-field" placeholder="Enter Weigth" (blur)="verifyInputData(i)"
              [(ngModel)]="room.weight" /></td>
          <td class="room-action-cell"><button mat-icon-button
              (click)="removeRoom(i)"><mat-icon>delete</mat-icon></button></td>
        </tr>
        <tr class="detail-row" *ngFor="let room of sortedData">
          <td>
            <mat-checkbox (change)="selectRoomForDeletion($event, room.id)"></mat-checkbox>
          </td>
          <td class="room-name-cell"><input class="input-field" readonly [value]="room?.name" /></td>
          <td class="room-weight-cell"><input class="input-field" readonly [value]="room?.weight" /></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" fxLayoutGap="20px">
  <button class="mat-raised-button mat-secondary" (click)="close()">
    {{ "Close" | translate }}
  </button>
  <button class="mat-raised-button mat-primary" (click)="saveRoom()">
    {{ "Save" }}
  </button>
</mat-dialog-actions>